module.exports = require("core-js-pure/stable/object/values");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/values.js
// module id = 611
// module chunks = 0